/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Close_Florian_AcceptInputs */

const fr_fair_close_florian_accept = /** @type {(inputs: Fair_Close_Florian_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le paiement a été annulé, veuillez réessayer.`)
};

/**

* @param {Fair_Close_Florian_AcceptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_close_florian_accept = /** @type {((inputs?: Fair_Close_Florian_AcceptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Close_Florian_AcceptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_close_florian_accept(inputs)
});